const ACCESS_CLAIM_KEYS = [
  "role",
  "roles",
  "userrole",
  "userroles",
  "rolename",
  "authority",
  "authorities",
  "permission",
  "permissions",
  "scope",
  "scopes",
];

const getClaimLabel = (claim) => {
  if (typeof claim === "string" || typeof claim === "number") {
    return String(claim);
  }

  if (!claim || typeof claim !== "object") return "";

  return (
    claim.name ||
    claim.code ||
    claim.value ||
    claim.role ||
    claim.authority ||
    claim.permission ||
    ""
  );
};

const normalizeClaim = (claim) =>
  getClaimLabel(claim)
    .trim()
    .replace(/^ROLE[_:\s-]*/i, "")
    .replace(/[\s.-]+/g, "_")
    .toUpperCase();

const collectClaims = (source) => {
  if (!source || typeof source !== "object") return [];

  return Object.entries(source).flatMap(([key, value]) => {
    const normalizedKey = key.replace(/[\s_-]+/g, "").toLowerCase();

    if (!ACCESS_CLAIM_KEYS.includes(normalizedKey)) return [];
    if (Array.isArray(value)) return value;
    if (typeof value === "string") return value.split(/[\s,]+/);
    return value ? [value] : [];
  });
};

export const getAccessClaims = (payload = {}) => {
  const claims = [
    ...collectClaims(payload),
    ...collectClaims(payload.user),
    ...collectClaims(payload.userDetails),
    ...collectClaims(payload.realm_access),
  ];

  return [...new Set(claims.map(normalizeClaim).filter(Boolean))];
};

export const isVendorAdmin = (payload = {}) => {
  const claims = getAccessClaims(payload);

  return claims.some((claim) =>
    ["VENDOR_ADMIN", "VENDORADMIN", "ADMIN_VENDOR"].includes(claim),
  );
};

export const isRootUser = (payload = {}) => {
  const rootValue = payload?.isRoot ?? payload?.root;

  return rootValue === true || String(rootValue).toLowerCase() === "true";
};

export const isSystemAdmin = (payload = {}) => {
  return isRootUser(payload);
};

export const hasAdminPortalAccess = (payload = {}) => {
  return Boolean(payload) && isRootUser(payload);
};

export const hasVendorPortalAccess = (payload = {}) => {
  return Boolean(payload) && !isRootUser(payload);
};

export const getPortalHomePath = (payload = {}) => {
  if (!payload) return "/sign-in";

  return isRootUser(payload) ? "/vendor-onboarding" : "/vendor-dashboard";
};
